import Select from 'components/Select';
import Colors from 'enums/Colors';
import React from 'react';
import styled from 'styled-components';
import { EnumReports } from './CardReports';
import LocalidadeDTO from 'models/perfil/LocalidadeDTO';
import { DatePicker } from 'antd';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import { ResumoRecursoCustomizado } from 'models/recursos-costumizados/ResumoRecursoCustomizado';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1100px;
        min-height: 320px;
        background-color: #ffffff;
        padding: 40px;
        gap: 2rem;

        -webkit-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        -moz-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
    `,

    Title: styled.h1`
        font-size: 26px;
        font-weight: 700;
        color: ${Colors.Blue};
        text-decoration: underline;
        text-underline-offset: calc(1rem);
    `,

    Content: styled.div`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 1rem;
        gap: 2rem;
        margin-top: 30px;
    `,

    SubTitle: styled.p`
        font-size: 14px;
        font-weight: 600;
        color: ${Colors.Blue};
    `,
};

interface ICardReportRecurso {
    title: string;
    userSchools: any[];
    setSchoolSelected: (value: any) => void;
    setNotFoundSchool: (value: boolean) => void;
    schoolName: string;
    setSchoolName: (value: string) => void;
    inputSchoolDisabled?: boolean;
    estados: any[];
    setEstadoSelected: (value: any) => void;
    cidades: LocalidadeDTO[];
    isLoadingCities: boolean;
    setcidadeSelected: (value: any) => void;
    cidadeSelected: any;
    setDataPeriodo: (datas: string[]) => void;
    handleReports: () => void;
    coursesItemRecurso: ResumoRecursoCustomizado[]
    setCourseSelected: (value: any) => void;
    loadingSubmite: number;
}

const CardReportRecurso = ({
    title,
    userSchools,
    setSchoolSelected,
    setNotFoundSchool,
    schoolName,
    setSchoolName,
    inputSchoolDisabled,
    estados,
    setEstadoSelected,
    cidades,
    isLoadingCities,
    setcidadeSelected,
    cidadeSelected,
    setDataPeriodo,
    handleReports,
    coursesItemRecurso,
    setCourseSelected,
    loadingSubmite
}: ICardReportRecurso) => {
    return <Styled.Container>
    <Styled.Title>{title}</Styled.Title>
    <Styled.Content>
            <div>
            <Styled.SubTitle>Curso</Styled.SubTitle>
            <Select
                style={{ width: '200px' }}
                placeholder="Selecione"
                onSelected={value => setCourseSelected(value)}
                itens={coursesItemRecurso.map((dados: any) => ({
                    value: dados.codigo,
                    label: dados.nome,
                }))}
            />
            </div>
        <div>
            <Styled.SubTitle>Estado</Styled.SubTitle>
            <Select
                style={{ width: '200px' }}
                placeholder="Selecione"
                onSelected={value => setEstadoSelected(value)}
                itens={estados.map((dados: any) => ({
                    value: dados.id,
                    label: dados.nome,
                }))}
            />
        </div>
        <div>
            <Styled.SubTitle>Cidade</Styled.SubTitle>
            <Select
                disabled={cidades?.length === 0 || isLoadingCities}
                placeholder="Selecione"
                style={{ width: '178px' }}
                value={{ label: cidadeSelected?.label, value: cidadeSelected?.value }}
                onSelected={value => setcidadeSelected(value)}
                itens={cidades?.map(dados => ({ label: dados.nome, value: dados.id }))}
            />
        </div>
        <div>
            {' '}
            <Styled.SubTitle>Escola</Styled.SubTitle>
            <Select
                disabled={inputSchoolDisabled}
                itens={userSchools.map(dados => ({
                    label: dados.name,
                    value: dados.inep,
                }))}
                onSelected={selected => {
                    setSchoolSelected({ schoolName: selected.label, schoolInep: selected.value });
                }}
                isSmall={false}
                width="100%"
            />
        </div>
        <div>
            <Styled.SubTitle>Período</Styled.SubTitle>
            <DatePicker.RangePicker
                size="large"
                style={{
                    height: 50,
                }}
                placeholder={['Início', 'Término']}
                allowEmpty={[false, false]}
                onChange={(date, dateString) => {
                    setDataPeriodo(dateString);
                }}
            />
        </div>
    </Styled.Content>
   <ButtonHomeV2
                  disabled={loadingSubmite === 2}
                  style={{ color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  onClick={() => {
                      loadingSubmite === -1 && handleReports();
                  }}
              >
                  {loadingSubmite === 2 ? <div className="loaderCreater" /> : 'Gerar relatório'}
              </ButtonHomeV2>
</Styled.Container>;
};

export default CardReportRecurso;
